export const base = '--font-base';
export const alt = '--font-alt';
